/* eslint-disable indent,no-trailing-spaces,dot-notation,space-in-parens,block-spacing,curly,keyword-spacing,prefer-template,no-unused-vars,padded-blocks,arrow-body-style,spaced-comment */
import activationsModalTemplate from './activations.modal.html';
import iPraticoModalTemplate from './iPratico.modal.html';
import vasActivationModalTemplate from './vasActivationInstruction.modal.html';
import _ from 'lodash';

class ServicesActivationsController {
    /* @ngInject */
    constructor($log, $q, $timeout, $state, MerchantConfigurationService,
                MerchantVasService, ModalFactory, TermsService, StorageService,
                NewTokenService, $rootScope, MerchantDetailService,
                StoreService) {
        const that = this;
        that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
        that.loading = {
            settings: false,
            terms: false
        };

        that.settings = {};
        that.active = false;
        that.currentUserWalletId = null;

        that.downloadedVasses = {};

        that.isDisable = true;

        let terms;

        this.onStoreSelected = () => {
            init();
          }

        const showAlert = (message) => {
            const checkInvalidTerms = (termsToCheck) => _.some(termsToCheck, (t) => t.mandatory && !t.accepted);
            const closeModal = (modal) => {
                modal.deactivate();
                $timeout(modal.destroy, 1000);
            };

            const modal = new ModalFactory({
                overlay: true,
                overlayClose: false,
                template: activationsModalTemplate,
                class: 'large',
                contentScope: {
                    service,
                    body,
                    terms: termsList,
                    checkInvalidTerms,
                    activate: () => {
                        if (checkInvalidTerms(this.terms)) {
                            // TODO: show error or something
                        } else {
                            closeModal(modal);
                            resolve();
                        }
                    },
                    cancel: () => {
                        closeModal(modal);
                        reject();
                    }
                }
            });

            modal.activate();
        };

        const showSuccessBanner = () => {
            $rootScope.$broadcast('messages:addSuccess');
        };

        const openTermsModal = (service, body, termsList) => $q((resolve, reject) => {
            const checkInvalidTerms = (termsToCheck) => _.some(termsToCheck, (t) => t.mandatory && !t.accepted);
            const closeModal = (modal) => {
                modal.deactivate();
                $timeout(modal.destroy, 1000);
            };

            const modal = new ModalFactory({
                overlay: true,
                overlayClose: false,
                template: activationsModalTemplate,
                class: 'large',
                contentScope: {
                    service,
                    body,
                    terms: termsList,
                    checkInvalidTerms,
                    activate: () => {
                        if (checkInvalidTerms(this.terms)) {
                            // TODO: show error or something
                        } else {
                            closeModal(modal);
                            resolve();
                        }
                    },
                    cancel: () => {
                        closeModal(modal);
                        reject();
                    }
                }
            });

            modal.activate();
        });

        const loadSettings = () => {
            that.merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
            var storeId = StoreService.getSelectedStore() ? StoreService.getSelectedStore().id : StoreService.getSavedStoreList()[0].id
            MerchantDetailService.getShopById(that.merchantProfile.business.id, storeId).then(res => {
                that.active = res.visible;
            })
        };

        // Carica termini
        const loadTerms = () => {
            if (that.loading.terms) return;
            that.loading.terms = true;
            TermsService.getVasMerchantTerms().then((termsResponse) => {
                terms = termsResponse;
            }).finally(() => {
                that.loading.terms = false;
            });
        };

        const updateVasses = (errorCallback) => {
            return MerchantVasService.getVasesForCurrent(that.merchantProfile.business.id).then(
                (resp) => {
                    if (resp.data['page']['totalElements'] === 0) {
                        return;
                    }
                    resp.data['_embedded']['vasses'].forEach((element) => {
                            const name = element['name'];
                            that.downloadedVasses[name] = element;
                        }
                    );
                },
                errorCallback
            );
        };

        const init = () => {
            that.downloadedVasses = {};
            loadSettings();
            that.currentUserWalletId = NewTokenService.getMerchantWalletID();
            $log.debug(that.currentUserWalletId);

            updateVasses();
        };

        that.$onInit = init;

        that.checkSuperAdminAndLevelB = () => {
            var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
            return that.isSuperAdmin && merchantProfile.business && merchantProfile.business.wallet && merchantProfile.business.wallet.type == 'BUSINESS' && merchantProfile.business.wallet.level == 'B';
        }


        that.isActiveVas = (vasType) => {
            return that.downloadedVasses[vasType] !== undefined && that.downloadedVasses[vasType]["status"] !== "UNSUBSCRIBED";
        };


        that.enablePromoClienti = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('OUTBOUND-MESSAGES');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['OUTBOUND-MESSAGES'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };

        that.enableSaltaLaCassa = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('ORDER-AND-PAY');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['ORDER-AND-PAY'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });

        };

        that.enableOrderAndPick = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('ORDER-AND-PICK');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['ORDER-AND-PICK'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };

        that.enableOrderAndDelivery = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('ORDER-AND-DELIVERY');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['ORDER-AND-DELIVERY'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };

        that.enableOfficeDelivery = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('OFFICE-DELIVERY');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['OFFICE-DELIVERY'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };

        that.enableOrderAtTable = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('ORDER-AT-TABLE');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['ORDER-AT-TABLE'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };

        that.enableBillAtTable = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('BILL-AT-TABLE');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['BILL-AT-TABLE'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };

        that.enableInvoices = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('INVOICES');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['INVOICES'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };


        that.enablePayWithAlipay = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('PAY-WITH-ALIPAY');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['PAY-WITH-ALIPAY'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };

        that.enableProjectWithAlipay = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('PROJECT-WITH-ALIPAY');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['PROJECT-WITH-ALIPAY'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };

        that.enableMobilePayWithAlipay = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('MOBILE-PAY-WITH-ALIPAY');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['MOBILE-PAY-WITH-ALIPAY'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };

        that.enableCoorporateCash = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('CORPORATE-CASH');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['CORPORATE-CASH'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };

        that.enableAlipayOnline = (enable) => {
            that.loading.settings = true;
            if (!that.isSuperAdmin) {
                that.showVasActivationModal('ONLINE-PAY-WITH-CONNECT');
                that.loading.settings = false;
                return;
            }
            const type = MerchantVasService.getVasesTypes()['ONLINE-PAY-WITH-CONNECT'];
            if (enable)
                MerchantVasService.enableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
            else
                MerchantVasService.disableVasForMe(type)
                    .then(updateVasses)
                    .finally(() => {
                        that.loading.settings = false;
                    });
        };


        this.showVasActivationModal = (vasName) => {
            const closeModal = () => {
                modal.deactivate();
                $timeout(modal.destroy, 1000);
            };

            const modal = new ModalFactory({
                overlay: true,
                overlayClose: true,
                template: vasActivationModalTemplate,
                class: 'default',
                contentScope: {
                    okFunc: closeModal,
                    attempt : (!that.isActiveVas(vasName))?"enable":""
                }
            });

            modal.activate();
        };


        const enableIPraticoVas = () => {
            $log.debug('Attivazione iPratico');
        };

        this.showIPraticoModal = () => {
            const closeModal = () => {
                modal.deactivate();
                $timeout(modal.destroy, 1000);
            };

            const modal = new ModalFactory({
                overlay: true,
                overlayClose: true,
                template: iPraticoModalTemplate,
                class: 'default',
                contentScope: {
                    activate: enableIPraticoVas
                }
            });

            modal.activate();
        };

        that.resetConfiguration = MerchantConfigurationService.resetMerchantStoreConfiguration;
    }
}

export default ServicesActivationsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/activations/activations.controller.js
 **/